import React from 'react';
import PropTypes from 'prop-types';

const Card = ({
  className, children, href, ...props
}) => {
  const finalProps = {
    className: `card score-card ${className}`,
    ...(href ? { href } : {}),
    ...props,
  };

  return React.createElement(
    href ? 'a' : 'div',
    finalProps,
    children,
  );
};

Card.defaultProps = {
  className: '',
  children: null,
  href: null,
};

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  href: PropTypes.string,
};

export default Card;
